import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";

const defaultValue = {
  userResume: null,
  setUserResume: () => {},
};

const HomepageResumeUploadContext = createContext(defaultValue);

export function HomepageResumeUploadProvider({ children }) {
  const router = useRouter();
  const [userResume, setUserResume] = useState(null);

  useEffect(() => {
    if (router.pathname !== "/") {
      setUserResume(null);
    }
  }, [router.pathname]);

  const value = useMemo(
    () => ({ userResume, setUserResume }),
    [userResume]
  );

  return (
    <HomepageResumeUploadContext.Provider value={value}>
      {children}
    </HomepageResumeUploadContext.Provider>
  );
}

export function useHomepageResumeUploadState() {
  return useContext(HomepageResumeUploadContext);
}
